
<div class="layout-footer">    
    <img src="assets/layout/images/ipsos.png" alt="Logo" height="50" width="100" class="mr-0"/>
    <span class="font-medium ml-2"></span>IPSOS 2024&nbsp;&nbsp;|&nbsp;&nbsp;<span>v1.1.67</span>    
</div>